import { useState, useLayoutEffect } from "react";
function Media(_a) {
    var query = _a.query, children = _a.children;
    var _b = useState(window.matchMedia(query).matches), matches = _b[0], setMatches = _b[1];
    useLayoutEffect(function () {
        var mql = window.matchMedia(query);
        var handler = function (e) { return setMatches(e.matches); };
        mql.addListener(handler);
        return function () {
            mql.removeListener(handler);
        };
    }, [query]);
    return children(matches);
}
export default Media;
